import { Logger } from '@vue-storefront/core';

const readOnlyMap = <K extends string, V>(iterable: Iterable<[K, V]>): ReadonlyMap<K, V> => {
  return new Map(iterable);
};

export const SERVER_ERROR_CODE = '101-100';
export const BAD_REQUEST_CODE = '102-100';

const errorMap = readOnlyMap([
  [SERVER_ERROR_CODE, 'Server error'],
  [BAD_REQUEST_CODE, 'Bad request'],
]);

export type DisplayErrorCode = Parameters<typeof errorMap['get']>[0];

const getDisplayError = (displayCode: DisplayErrorCode) => {
  const displayMessage = errorMap.get(displayCode);

  if (!displayMessage) {
    Logger.warn(`${displayCode} is missing in error map.`);
  }

  return {
    displayCode,
    displayMessage,
  };
};

export default getDisplayError;
